import React from 'react';
import { connect } from 'react-redux'

import Contact from './components/Contact';
import Sent from './components/Sent';


const Component = ({ step }) => {
  switch(step) {
    case "SENT":
      return (
        <Sent />
      );
    default:
      return (
        <Contact />
      );
  }
}

Component.displayName = "ContactForm";

function getState(state) {
  return {
    step: state.contact.step || "",
  };
}

export default connect(getState)(Component);



// WEBPACK FOOTER //
// ./src/forms/Contact/index.js